exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-0f6bfa3b] {\n  margin-bottom: 15px;\n}\n.btn-holder[data-v-0f6bfa3b] {\n  text-align: center;\n  margin-bottom: 15px;\n}\n.loading-holder[data-v-0f6bfa3b] {\n  position: relative;\n  padding: 15px 0;\n}\n", ""]);

// exports
